import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { PushSponsor } from '../models/push-sponsor';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PushSponsorService {

  public spinner: boolean = false;
  
  private itemDoc: AngularFirestoreDocument<PushSponsor>;
  private item: Observable<PushSponsor>;

  constructor(private db: AngularFirestore,
    public _authService: AuthService
    ) { }

  select() {
    return this.db.collection<PushSponsor>('sbccv_push_sponsors', ref => ref.orderBy('date_send', 'desc')).snapshotChanges();
  }

  selectByEvent(sponsor_id) {
    return this.db.collection<PushSponsor>('sbccv_push_sponsors', ref => ref.where('sponsor_id', '==', sponsor_id)).snapshotChanges();
  } 

  selectById(id) {
    this.itemDoc = this.db.doc<PushSponsor>('sbccv_push_sponsors/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }


  insert(push: PushSponsor) {
    delete push.id
    return this.db.collection('sbccv_push_sponsors').add(Object.assign({}, push))
  }

  update(push: PushSponsor) {
    let id = push.id
    delete push.id
    return this.db.collection('sbccv_push_sponsors').doc(id).set(Object.assign({}, push))
  }

  delete(push_id: any) {
    return this.db.collection('sbccv_push_sponsors').doc(push_id).delete();
  }

}
